import * as Blockly from 'blockly/core';
// import { VmtFieldFlyoutText } from '../fields/VmtFlyout/VmtFlyoutEditField';
// import { createMinusField } from '../fields/field_minus';
// import { createPlusField } from '../fields/field_plus';
// import { getExtraBlockState } from '../fields/serialization_helper';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';

const minusImage =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAw' +
    'MC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPS' +
    'JNMTggMTFoLTEyYy0xLjEwNCAwLTIgLjg5Ni0yIDJzLjg5NiAyIDIgMmgxMmMxLjEwNCAw' +
    'IDItLjg5NiAyLTJzLS44OTYtMi0yLTJ6IiBmaWxsPSJ3aGl0ZSIgLz48L3N2Zz4K';

/**
 * The parameter block.
 * @type {Blockly.Block}
 */
Blockly.Blocks['vmt_parameter'] = {
    /**
    * Initializes the block.
    * @this {Blockly.Block}
    */
    init: function () {
        this.appendValueInput('TOP')
            .appendField(new Blockly.FieldImage(minusImage, 20, 20), 'MINUS');
        this.appendValueInput('PARAM_INPUT');

        this.setInputsInline(true)
        this.setPreviousStatement(true, 'Parameter');
        this.setNextStatement(true, 'Parameter');

        this.setTooltip('');
        this.setHelpUrl('');
        this.setColour(REUSABLE_BRICK_COLOR);

        this.setDeletable(false);
        this.setMovable(false);

        // just to make the mouse cursor change to pointer
        // the rest of the logic is in the onchange event
        const minusField = this.getField('MINUS');
        minusField.setOnClickHandler(function () { });
        minusField.setTooltip('Remove parameter');
        // this.paramDropInput_ = this.getInput('TOP');

        // Ensure the workspace is available before trying to add a child block
        if (!this.workspace) return;

        // Create a shadow block to be displayed in the block
        let topInput = this.getInput("TOP"); // 
        topInput.setCheck(['null']); // disable any type of connection to the top input
        const paramDropShadowXml = Blockly.utils.xml.textToDom('<shadow type="vmt_parameter_reference"/>');
        topInput.setShadowDom(paramDropShadowXml);
    },

    /**
     * Called whenever anything on the workspace changes.
     * It checks the state of the block and calls the correct helper function.
     * @param {Blockly.Events.Abstract} e Change event.
     * @this {Blockly.BlockSvg}
     */
    onchange: function (e) {
        // console.log('onchange >vmt_parameter<', this.getField('PARAMETER_NAME').getText(), this.id, e);

        // if (e.type === Blockly.Events.FINISHED_LOADING) {
        if ((e.type === Blockly.Events.BLOCK_CREATE && e.ids.includes(this.id)) || e.type === Blockly.Events.FINISHED_LOADING) {
            const parentBlock = this.getSurroundParent();
            if (!parentBlock) {
                return;
            }
            if (parentBlock.type === 'vmt_reusable_brick_init_statement') {
                /** @type {{type: string, name: string, paramId: string}} */
                const paramData = JSON.parse(this.data);
                const minusField = this.getField('MINUS');
                minusField.setOnClickHandler(parentBlock.minus.bind(parentBlock, paramData.paramId));

                // update 'vmt_parameter_reference' shadow block
                const shadowBlock = this.getInput('TOP').connection.targetBlock();
                if (shadowBlock) {
                    shadowBlock.setFieldValue(paramData.name, 'PARAMETER_NAME');
                    shadowBlock.data = JSON.stringify({ ...JSON.parse(this.data), type: 'parameter_ref', parentBlockId: parentBlock.id });
                }
            }
        }
    },
};
